import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 26,
	viewBox: "0 0 26 26",
	width: 26,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m21.4325 8.50542-5.5125-5.5125c-.0731-.07311-.16-.13108-.2556-.1706-.0956-.03953-.1981-.05983-.3015-.05975h-9.45001c-.41772 0-.81832.16594-1.11369.46131s-.46131.69598-.46131 1.11369v17.32503c0 .4177.16594.8183.46131 1.1137.29537.2953.69597.4613 1.11369.4613h14.17501c.4177 0 .8183-.166 1.1137-.4613.2954-.2954.4613-.696.4613-1.1137v-12.60003c.0001-.10344-.0202-.20589-.0598-.30149-.0395-.0956-.0974-.18247-.1706-.25566zm-5.2821-3.05452 2.8242 2.82417h-2.8242zm3.9375 16.2117h-14.17501v-17.32503h8.66251v4.725c0 .20886.083.40916.2306.55685.1477.14768.348.23065.5569.23065h4.725z",
		fill: "#000"
	})
});
export default SvgFile;
